import { useQuery, QueryStatus } from 'react-query';
import {
  getQueryKey,
  validateCompanyShareToken,
  ValidateCompanyShareToken,
} from './queryFn';

interface ValidCompanyShareToken extends ValidateCompanyShareToken {
  status: QueryStatus;
}
export const useValidateCompanyShareToken = (
  token: string,
  companyId: string | undefined
): ValidCompanyShareToken => {
  const { data, status } = useQuery(
    getQueryKey(token, companyId ?? ''),
    validateCompanyShareToken,
    {
      staleTime: Infinity,
      retry: 1,
      refetchOnMount: false,
      enabled:
        typeof token === 'string' &&
        token !== '' &&
        typeof companyId === 'string',
      refetchOnWindowFocus: false,
    }
  );
  if (status === 'success') {
    return {
      isValidShareToken: data.isValidShareToken,
      logo: data.logo ?? '',
      status,
    };
  }
  return { isValidShareToken: false, status };
};
